import styles from "./menu-icon.module.css"

const hamburgerSVG = (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 3.1665H13.5M2.5 7.99984H8.16667M2.5 12.8332H13.5"
      stroke="#212020"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.26316"
    />
  </svg>
)

const closeSVG = (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m2.5 12.83 11-9.66M2.5 3.17l11 9.66"
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.26316"
    />
  </svg>
)

// Menu icon component, used in header.
export function MenuIcon(props: React.ComponentProps<"span"> & { icon: "close" | "hamburger" }) {
  const icon = props.icon === "close" ? closeSVG : hamburgerSVG

  return (
    <span className={styles["container"]} role="button" {...props}>
      {icon}
    </span>
  )
}
